import "./PublicHeader.scss";
import React from "react";
import {
  IonBackButton,
  IonButtons,
  IonHeader,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

interface Props {
  title: string;
}

const PublicHeader: React.FC<Props> = ({ title }) => {
  return (
    <IonHeader className="public-header ion-no-border" mode="ios">
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
          <IonBackButton
            text=""
            defaultHref="/"
          />
        </IonButtons>
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default PublicHeader;
